// import i18n from '@/plugins/i18n';

import i18n from '@/plugins/i18n';

const pagesGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('apm.service-instance-load'),
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        content: [],
        hideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      sortOrder: 'DES',
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_page_pv',
      queryMetricType: 'readCustomMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
  areaCharts: [
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('userCentricPageLoadTitle'),
      height: '12.5em',
      header: {
        title: i18n.global.t('userCentricPageLoadTitle'),
        titleIcon: '',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
      },
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'browser_app_page_redirect_avg,browser_app_page_dns_avg,browser_app_page_ttfb_avg,browser_app_page_tcp_avg,browser_app_page_trans_avg,browser_app_page_dom_analysis_avg,browser_app_page_fpt_avg,browser_app_page_dom_ready_avg,browser_app_page_load_page_avg,browser_app_page_res_avg,browser_app_page_ssl_avg,browser_app_page_ttl_avg,browser_app_page_first_pack_avg,browser_app_page_fmp_avg',
      queryMetricType: 'readCustomMetricsValues', //Value changed from readMetricsValues to readCustomMetricsValues
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'P50, P75, P90, P95, P99',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('bm.load-and-execution-time'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      widthInPer: '100%',
      title: i18n.global.t('errorTitle'),
      height: '12.5em',
      header: {
        title: i18n.global.t('errorTitle'),
        titleIcon: 'error',
        content: [],
        toolbar: true,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: i18n.global.t('view-errors'),
          route: 'errorTable',
        },
        displayCustomButton: true,
      },
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'browser_app_page_resource_error_sum, browser_app_page_js_error_sum, browser_app_page_ajax_error_sum, browser_app_page_unknown_error_sum',
      queryMetricType: 'readCustomMetricsValues',
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'ms',
      metricLabels: 'Resources, Js, Ajax, Others',
      labelsIndex: '0, 1, 2, 3',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  barCharts: [
    {
      width: '48%',
      title: i18n.global.t('bm.user-impacted-by-errors'),
      header: {
        title: i18n.global.t('bm.user-impacted-by-errors'),
        titleIcon: 'error',
        content: [],
        hideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
        hideCustomToolbarButtons: true,
      },
      chartColor: ['#008FFB'],
      height: '25em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_user_impacted',
      queryMetricType: 'readCustomMetricsValues',

      chartType: 'ApexChartBar',
      // unit: 'CPM - calls per minute',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
  heatMap: [
    {
      width: '97.7%',
      height: '100%',
    },
  ],
});
export default pagesGraphs;
